import { Rect } from '#types/types';

export const getWorkspaceRasterDimensions = (rect: Rect) => {
  const { w, h } = rect;

  if (w <= 0 || h <= 0) {
    return { width: 1, height: 1, scale: 1 };
  }

  const longestSide = Math.max(w, h);
  const scale = 1440 / longestSide;
  const width = Math.max(1, Math.round(w * scale));
  const height = Math.max(1, Math.round(h * scale));

  return { width, height, scale };
};
